import toast from 'react-hot-toast';

// Several queries often fail at once on the same network issue; passing the message
// as toast id makes react-hot-toast show a single pop-up instead of one per query.
const showErrorOnce = (message: string) => {
  toast.error(message, { id: `error:${message}` });
};

interface ApiError {
  message?: string;
  response?: {
    status?: number;
    data?: { title?: string; detail?: string | { msg?: string }[] };
  };
}

export const handleError = (error: unknown) => {
  if (error) {
    const apiError = error as ApiError;
    const detail = apiError.response?.data?.detail;
    if (apiError.response?.data?.title) {
      showErrorOnce(apiError.response.data.title);
    } else if (typeof detail === 'string') {
      showErrorOnce(detail);
    } else if (Array.isArray(detail)) {
      showErrorOnce(detail[0]?.msg || 'An unknown error occurred.');
    } else {
      showErrorOnce(apiError.message || 'An unknown error occurred.');
    }
    switch (apiError.response?.status) {
      case 401: {
        // Redirection vers la page de connexion
        window.location.href = '/login';
        break;
      }
      case 404: {
        showErrorOnce('The requested resource was not found (404).');
        break;
      }
    }
  }
};
